module.exports = __webpack_public_path__ + "img/full0-min.4b4f7576.png";